declare namespace $ {

	export class $mol_icon_pickaxe extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=pickaxe.view.tree.d.ts.map